export default {
	props:{
		siteKey: String,
	},
	data(){
		return {
			isLoaded:false,
			isFirstOpen:true,
		}
	},
	watch: {},
	computed: {},
	methods: {
		init(){
			this.isLoaded = true;
		},
		generateRecaptchaToken(action){
			if(!this.isLoaded){
				alert('gc not loaded!');
				return '';
			}
			return new Promise((resolve, reject) => {
				window.grecaptcha.ready(()=>{
					window.grecaptcha.execute(this.siteKey, {action:action})
						.then((token)=>{ resolve(token); })
						.catch((err)=>{ reject(err); });
				});
			});
		},
	},
	created() {
		let self = this;
		ITTI.defer(function (){
			self.init();
		}, ['googleReCaptchaV3']);
	},
	template: `
<span class="qit-google-recaptcha-v3"><slot></slot></span>
`,
}